import { render, staticRenderFns } from "./PurchaseListDetail.vue?vue&type=template&id=0cb924e0&scoped=true"
import script from "./PurchaseListDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseListDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseListDetail.vue?vue&type=style&index=0&id=0cb924e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb924e0",
  null
  
)

export default component.exports